export default __webpack_public_path__ + "static/media/baycruisemap.4d927e11.jpg";